import { stat } from "fs";

const customerSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_CUSTOMERSEARCH: (state, customerSearch) => {
      state.data = customerSearch
    }
  }
}

export default customerSearch



// WEBPACK FOOTER //
// ./src/store/modules/customerSearch.js